/* Types used to store Stuff in the Cloud */

import * as _ST from 'spinnaxBase/logic/types_storage';
import * as _COM from 'spinnaxBase/logic/Com_types';
import * as _M from 'spinnaxBase/logic/model';

export * from 'spinnaxBase/logic/types_storage';

export type PlayInformation = _ST.PlayDetails;

export type PlayStepV1 = _ST.PlayStep;
// export type PlayStep = ST.PlayStep;

export const RecordSample = _M.RecordSample;
/* eslint-disable @typescript-eslint/no-redeclare */
export type RecordSample = _ST.RecordSample;

export const PlayDetails = _M.PlayDetails;
export type PlayDetails = _ST.PlayDetails;
